/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';
import { isElementOverflown } from '@lt/components/utils/userflow';
import styles from './shortInfo.module.css';

class ShortInfo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOverflown: undefined,
      isClamped: true,
    };
    this.containerRef = React.createRef();
    this.handleOverflow = this.handleOverflow.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.observer = new ResizeObserver(this.handleOverflow);
    this.observer.observe(this.container);
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.unobserve(this.container);
    }
  }

  handleOverflow() {
    const { isClamped } = this.state;
    if (isClamped) {
      const isOverflown = isElementOverflown(this.container);
      this.setState({ isOverflown });
    }
  }

  handleClick() {
    this.setState({ isClamped: false });
  }

  get container() {
    return this.containerRef.current;
  }

  render() {
    const { isOverflown, isClamped } = this.state;
    const { text, maxLines, lineHeight, isMobile } = this.props;
    const showExpandBtn = isOverflown && isClamped;
    const maxHeight = !isClamped ? 'none' : `${maxLines * lineHeight}px`;
    const height = lineHeight * 2;
    return (
      <div
        ref={this.containerRef}
        className={classnames(styles.shortInfo, {
          [styles.showMobileShadow]: isMobile && showExpandBtn,
        })}
        onClick={isMobile ? this.handleClick : undefined}
        style={{ maxHeight, heightValue: height }}
      >
        {text}
        {!isMobile && showExpandBtn && (
          <div className={styles.button} onClick={this.handleClick}>
            Подробнее
          </div>
        )}
      </div>
    );
  }
}

ShortInfo.defaultProps = {
  maxLines: 3,
  lineHeight: 18,
  isMobile: false,
};

ShortInfo.propTypes = {
  text: PropTypes.string.isRequired,
  maxLines: PropTypes.number,
  lineHeight: PropTypes.number,
  isMobile: PropTypes.bool,
};

export default ShortInfo;
